/**
 * PDP minimal 2026-08 — visore immagini a tutto schermo.
 *
 * Il tema non ha un lightbox: le immagini sono avvolte in un <a> verso la
 * versione grande, ma media-gallery.js annulla il click (evt.preventDefault())
 * e lascia solo lo zoom al passaggio del mouse, che su mobile non esiste.
 *
 * Qui il click apre il visore: frecce avanti/indietro, contatore, tastiera,
 * swipe, e un secondo click che ingrandisce l'immagine con panoramica.
 *
 * Rollback: togliere il tag <script> in sections/main-product.liquid.
 */
(() => {
  if (window.pdpLightboxLoaded) return;
  window.pdpLightboxLoaded = true;

  const SVG_NS = 'http://www.w3.org/2000/svg';
  const ZOOM_SCALE = 2.2;
  const SWIPE_MIN = 40;
  const TAP_MAX = 10;

  const i18n = (() => {
    const fallback = {
      prev: 'Immagine precedente', next: 'Immagine successiva', close: 'Chiudi', of: 'di'
    };
    const el = document.getElementById('pdp-lightbox-i18n');
    if (!el) return fallback;
    try {
      return Object.assign(fallback, JSON.parse(el.textContent));
    } catch (e) {
      return fallback;
    }
  })();

  const gallery = document.querySelector('.product-main #product-media');
  if (!gallery) return;

  /** Ricalcola le immagini disponibili: le varianti possono nasconderne alcune. */
  function collectSlides() {
    return [...gallery.querySelectorAll('.media-viewer__item')]
      .filter((item) => {
        if (item.dataset.mediaType && item.dataset.mediaType !== 'image') return false;
        if (!item.querySelector('img')) return false;
        return item.offsetParent !== null || item.getClientRects().length > 0;
      })
      .map((item) => {
        const link = item.querySelector('.js-zoom-link');
        const img = item.querySelector('img');
        return {
          src: (link && link.getAttribute('href')) || img.currentSrc || img.src,
          alt: img.getAttribute('alt') || '',
          item
        };
      });
  }

  let slides = [];
  let index = 0;
  let zoomed = false;
  let lastFocused = null;
  let root = null;
  let imgEl = null;
  let counterEl = null;
  let prevBtn = null;
  let nextBtn = null;

  function icon(path, size) {
    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', size);
    svg.setAttribute('height', size);
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.5');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    const p = document.createElementNS(SVG_NS, 'path');
    p.setAttribute('d', path);
    svg.appendChild(p);
    return svg;
  }

  function button(cls, label, path, size) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.setAttribute('aria-label', label);
    b.appendChild(icon(path, size));
    return b;
  }

  function build() {
    root = document.createElement('div');
    root.className = 'pdp-lightbox';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', i18n.close);
    root.hidden = true;

    const closeBtn = button('pdp-lightbox__close', i18n.close, 'M18 6 6 18M6 6l12 12', 20);
    prevBtn = button('pdp-lightbox__nav pdp-lightbox__nav--prev', i18n.prev, 'M15 5l-7 7 7 7', 22);
    nextBtn = button('pdp-lightbox__nav pdp-lightbox__nav--next', i18n.next, 'M9 5l7 7-7 7', 22);

    const stage = document.createElement('div');
    stage.className = 'pdp-lightbox__stage';
    imgEl = document.createElement('img');
    imgEl.className = 'pdp-lightbox__img';
    imgEl.decoding = 'async';
    stage.appendChild(imgEl);

    counterEl = document.createElement('p');
    counterEl.className = 'pdp-lightbox__counter';

    root.append(closeBtn, prevBtn, stage, nextBtn, counterEl);
    document.body.appendChild(root);

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', () => go(-1));
    nextBtn.addEventListener('click', () => go(1));
    root.addEventListener('click', (evt) => {
      if (evt.target === root || evt.target === stage) close();
    });
    imgEl.addEventListener('click', toggleZoom);
    imgEl.addEventListener('mousemove', pan);
    stage.addEventListener('touchstart', onTouchStart, { passive: true });
    stage.addEventListener('touchmove', onTouchMove, { passive: false });
    stage.addEventListener('touchend', onTouchEnd, { passive: true });
    document.addEventListener('keydown', onKeyDown);
  }

  function render() {
    const slide = slides[index];
    if (!slide) return;
    setZoom(false);
    imgEl.src = slide.src;
    imgEl.alt = slide.alt;
    counterEl.textContent = `${index + 1} ${i18n.of} ${slides.length}`;
    const single = slides.length < 2;
    prevBtn.hidden = single;
    nextBtn.hidden = single;
    counterEl.hidden = single;
  }

  function open(startIndex) {
    if (!root) build();
    slides = collectSlides();
    if (!slides.length) return;
    index = Math.max(0, Math.min(startIndex, slides.length - 1));
    lastFocused = document.activeElement;
    render();
    root.hidden = false;
    document.body.classList.add('pdp-lightbox-open');
    root.querySelector('.pdp-lightbox__close').focus();
  }

  function close() {
    if (!root || root.hidden) return;
    setZoom(false);
    document.body.classList.remove('pdp-lightbox-open');
    root.hidden = true;
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function go(delta) {
    if (slides.length < 2) return;
    index = (index + delta + slides.length) % slides.length;
    render();
  }

  function setZoom(on) {
    zoomed = on;
    imgEl.classList.toggle('is-zoomed', on);
    if (!on) imgEl.style.transform = '';
  }

  function toggleZoom(evt) {
    evt.stopPropagation();
    setZoom(!zoomed);
    if (zoomed) pan(evt);
  }

  function pan(evt) {
    if (!zoomed) return;
    panTo(evt.clientX, evt.clientY);
  }

  function panTo(clientX, clientY) {
    const r = imgEl.getBoundingClientRect();
    const x = ((clientX - r.left) / r.width - 0.5) * -100 * (ZOOM_SCALE - 1);
    const y = ((clientY - r.top) / r.height - 0.5) * -100 * (ZOOM_SCALE - 1);
    imgEl.style.transform = `scale(${ZOOM_SCALE}) translate(${x / ZOOM_SCALE}%, ${y / ZOOM_SCALE}%)`;
  }

  let touchStartX = 0;
  function onTouchStart(evt) { touchStartX = evt.changedTouches[0].clientX; }

  function onTouchMove(evt) {
    if (!zoomed) return;
    evt.preventDefault();
    panTo(evt.touches[0].clientX, evt.touches[0].clientY);
  }

  function onTouchEnd(evt) {
    if (zoomed) return; // col dito si sposta dentro l'immagine, non tra le foto
    const dx = evt.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > SWIPE_MIN) go(dx < 0 ? 1 : -1);
  }

  function onKeyDown(evt) {
    if (!root || root.hidden) return;
    if (evt.key === 'Escape') { evt.preventDefault(); close(); }
    else if (evt.key === 'ArrowRight') { evt.preventDefault(); go(1); }
    else if (evt.key === 'ArrowLeft') { evt.preventDefault(); go(-1); }
  }

  // Apertura dalla galleria: distingue il tap dallo swipe della slitta mobile.
  let downX = 0;
  let downY = 0;
  gallery.addEventListener('pointerdown', (evt) => { downX = evt.clientX; downY = evt.clientY; });
  gallery.addEventListener('click', (evt) => {
    const item = evt.target.closest('.media-viewer__item');
    if (!item) return;
    if (evt.target.closest('.media-xr-button, deferred-media, product-model, video, .media-ctrl')) return;
    if (Math.abs(evt.clientX - downX) > TAP_MAX || Math.abs(evt.clientY - downY) > TAP_MAX) return;
    const list = collectSlides();
    const i = list.findIndex((s) => s.item === item);
    if (i === -1) return;
    evt.preventDefault();
    open(i);
  });
})();
